<div class="tabs-bar">
  <div class="tabs-holder">
    @for (tab of tabs; track tab) {
      @if (tab.allowed) {
        <div
          class="tab"
        [ngClass]="{
          'tabs-selected': tab.active,
          'tabs-unselected': !tab.active
        }">
          <span
          routerLink="/{{ tab.parent }}{{
            tab.path?.length ? '/' + tab.path : ''
          }}{{ tab.id?.length ? '/' + tab.id : '' }}"
            routerLinkActive="active"
            ><mat-icon matTooltip="{{ tab.title }}" class="tabs-icon">
            {{ tab.icon }}</mat-icon
            >
            <span class="hide show-md">
              {{ tab.title }}
            </span>
          </span>
        </div>
      }
    }
  </div>
</div>
